
import React, { Fragment, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import '../../CSS/Table.css';
import { connect } from 'react-redux';
import { config } from '../../constant';

import { tableMock } from '../../../Mock/MockJson';
import localStorage from '../../../../../utils/localStorage';
import StyledTable from "../../../../../commons/styles/table";
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { Spin, Tag, Tooltip, Badge } from 'antd';
import { API_FILE, IPAddress } from '../../../../../commons/api';
import { tableTranslation } from '../../../Utils/Adapter/translationAdapter';
import { DownloadOutlined, BellFilled } from '@ant-design/icons';
import { getChartDataWithSelection, getChartDataWithoutSelection } from '../../ChartCalls';

const TableComponent = (props) => {
  const [columns, setColumns] = useState([]);
  const [tabledata, setTabledata] = useState([]);
  const [loading,] = useState(false);
  const [reportName, setReportName] = useState('');
  const [, setExtraKeys] = useState({ Type: 'Running' });
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
    // updateData();
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const updateData = async (data) => {
    try {
      const { graphprops } = props;
      const columnConfig = JSON.parse(graphprops[graphprops.graph].columns);
      const columnsList = [];

      if (columnConfig && Array.isArray(columnConfig)) {
        columnConfig.forEach((column) => {
          if (column.isUTC) {
            data = data.map((dataa) => {
              const date = moment.utc(dataa[column.key]).toDate();
              return {
                ...dataa,
                [column.key]: moment(date).local().format('YYYY-MM-DD HH:mm:ss')
              };
            });
          }
          columnsList.push({
            title: column.title,
            dataIndex: column.key,
            key: column.key,
            render: (text, record) => (
              <span style={{ color: record.Color }}>
                {column.showColor && record[`${column.key}_Color`] ? (
                  <Tag color={record[`${column.key}_Color`]} key={column.key}>
                    {text}
                  </Tag>
                ) : (
                  text
                )}
              </span>
            )
          });
        });
      }

      const reportPayload = data.map((dataObject) => {
        const newObj = {};
        columnsList.forEach((column) => {
          newObj[column.title] = dataObject[column.key] !== undefined ? dataObject[column.key] : '';
        });
        return newObj;
      });

      const reportName = await getReportNametoDownload(reportPayload);
      const translationTable = await tableTranslation(columnsList, props.translationCache, props.language);

      setColumns(translationTable);
      setTabledata(data);
      setReportName(reportName.file || '');
    } catch (e) {
      setColumns([]);
      setTabledata([]);
    }
  };

  const getReportNametoDownload = async (excelData) => {
    const { graphprops } = props;
    const payload = {
      Consumption: graphprops.title,
      Data: excelData || [],
      ...graphprops.excelObj,
      Name: graphprops.dashboardName,
      PortName: ' ',
      ReportType: 'singleHierarchy',
      Summary: [],
      SummaryReportType: 'singleHierarchy',
      SummaryType: 'false',
      WeeklySummary: [],
      SelectedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      GeneratedDate: moment().format('YYYY-MM-DD HH:mm:ss')
    };
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const options = {
      method: 'POST',
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: JSON.stringify(payload)
    };
    try {
      const { data } = await axios(options);
      return data;
    } catch {
      return '';
    }
  };

  const getData = async () => {

    requestCheck.current = false;
    setErrorInAPI(false);
    setNoDataInDB(false);
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = tableMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') ||
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    // json= [
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "BCG Group2 isolated",
    //     "Criticality": "High",
    //     "Fault Code": "223006",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Interruption error",
    //     "Criticality": "High",
    //     "Fault Code": "30050",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Battery Charger Faulty",
    //     "Criticality": "High",
    //     "Fault Code": "30053",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:54:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC in Emergency Mode",
    //     "Criticality": "High",
    //     "Fault Code": "11124",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Battery Charger Faulty",
    //     "Criticality": "High",
    //     "Fault Code": "30053",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Interruption error",
    //     "Criticality": "High",
    //     "Fault Code": "30050",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Transmission error",
    //     "Criticality": "High",
    //     "Fault Code": "30004",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "BCG Group1 isolated",
    //     "Criticality": "High",
    //     "Fault Code": "223005",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Transmission error",
    //     "Criticality": "High",
    //     "Fault Code": "30004",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Interruption error",
    //     "Criticality": "High",
    //     "Fault Code": "30050",
    //     "TimeStamp": "2025-06-21 06:44:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Transmission error",
    //     "Criticality": "High",
    //     "Fault Code": "30004",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Interruption error",
    //     "Criticality": "High",
    //     "Fault Code": "30050",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Transmission error",
    //     "Criticality": "High",
    //     "Fault Code": "30004",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Transmission error",
    //     "Criticality": "High",
    //     "Fault Code": "30004",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Interruption error",
    //     "Criticality": "High",
    //     "Fault Code": "30050",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:34:46"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Transmission error",
    //     "Criticality": "High",
    //     "Fault Code": "30004",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11125",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC in Emergency Mode",
    //     "Criticality": "High",
    //     "Fault Code": "11124",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC in Emergency Mode",
    //     "Criticality": "High",
    //     "Fault Code": "11124",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Transmission error",
    //     "Criticality": "High",
    //     "Fault Code": "30004",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Battery Charger Faulty",
    //     "Criticality": "High",
    //     "Fault Code": "30053",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Interruption error",
    //     "Criticality": "High",
    //     "Fault Code": "30050",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "HVAC in Emergency Mode",
    //     "Criticality": "High",
    //     "Fault Code": "11124",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   },
    //   {
    //     "Train No": "MRS0011",
    //     "Notification": "Major Fault",
    //     "Criticality": "High",
    //     "Fault Code": "11122",
    //     "TimeStamp": "2025-06-21 06:29:24"
    //   }
    // ];
 console.log(json,'jsondaddaddadda');
    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && !graphprops.enableMock)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      updateData(json);
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  console.log(tabledata,'returnnnnnnn',columns,DeviceCode);

  return (
    <Fragment>
      <div>
        {reportName && (
          <a
            href={`${IPAddress.LOCAL}/api/reports/${reportName}`}
            style={{ fontWeight: 'bold' }}
          >
            <DownloadOutlined
              style={{ color: 'rgb(191, 191, 191)', float: 'right' }}
            />
          </a>
        )}
      </div>
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {props.graphprops.title === 'Events Notifications & Alerts' && props.graphprops.dashboardName === 'Renewable Energy' && (
            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
              <Tooltip title={'Running'}>
                <BellFilled
                  style={{ color: 'red', fontSize: '30px' }}
                  onClick={() => {
                    setExtraKeys({ Type: 'Running' });
                    getData({ Type: 'Running' });
                  }}
                />
              </Tooltip>
              <Tooltip title={'Stopped'}>
                <BellFilled
                  style={{ color: 'green', fontSize: '30px' }}
                  onClick={() => {
                    setExtraKeys({ Type: 'Stopped' });
                    getData({ Type: 'Stopped' });
                  }}
                />
              </Tooltip>
            </div>
          )}

          {loading === false && columns.length > 0 ? (
            <span>
              {props.graphprops.title === 'Alerts' && (
                <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                  <div style={{ marginRight: '10px', color: 'white' }}>
                    - {props.language !== 'English' ? '警告-3低' : 'Warning-3 Low'}
                  </div>
                  <Badge color="rgb(176, 71, 71)" />
                  <div style={{ marginRight: '10px', color: 'white' }}>
                    - {props.language !== 'English' ? '警告-3高' : 'Warning-3 High'}
                  </div>
                  <Badge color="rgb(168, 3, 3)" />
                  <div style={{ marginRight: '10px', color: 'white' }}>
                    - {props.language !== 'English' ? '警告-2低' : 'Warning-2 Low'}
                  </div>
                  <Badge color="rgb(208, 151, 98)" />
                  <div style={{ marginRight: '10px', color: 'white' }}>
                    - {props.language !== 'English' ? '警告-2高' : 'Warning-2 High'}
                  </div>
                  <Badge color="rgb(176, 116, 5)" />
                  <div style={{ marginRight: '10px', color: 'white' }}>
                    - {props.language !== 'English' ? '警告-1低' : 'Warning-1 Low'}
                  </div>
                  <Badge color="rgb(137, 183, 185)" />
                  <div style={{ marginRight: '10px', color: 'white' }}>
                    - {props.language !== 'English' ? '警告-1高' : 'Warning-1 High'}
                  </div>
                  <Badge color="rgb(3, 160, 168)" />
                </div>
              )}

              <StyledTable size="small"
                style={{ padding: '0px 10px', marginTop: '12px' }}
                columns={columns && Array.isArray(columns) ? columns : []}
                dataSource={tabledata && Array.isArray(tabledata) ? tabledata : []}
                scroll={{ y: 'auto', x: 200 }}
                pagination={tabledata.length <= (props.graphprops.table?.tableSize || 10) ? false : { pageSize: props.graphprops.table?.tableSize }}
              />
            </span>
          ) : (
            <div style={{ textAlign: 'center', color: 'white', marginTop: '10%' }}>
              <h2 style={{ color: 'white' }}>
                <Spin spinning={loading} tip="Loading..." ></Spin>
              </h2>
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone,
});

export default connect(mapStateToProps)(TableComponent);